// Editorial preview authentication.
//
// A draft Perspective is protected server-side by a PREVIEW_TOKEN. The token
// is never bundled into the frontend and is never placed in URLs — the
// editor pastes it once via the /preview gate, we verify it against the
// backend, and it lives in sessionStorage only for that tab.
//
// This module exposes tiny helpers so callers don't need to know the storage
// keys or header format.

const TOKEN_KEY = "ttl101_preview_token";
const FLAG_KEY = "ttl101_preview_perspectives";

export const getPreviewToken = () => {
  try { return window.sessionStorage?.getItem(TOKEN_KEY) || null; } catch { return null; }
};

export const setPreviewToken = (token) => {
  try {
    window.sessionStorage?.setItem(TOKEN_KEY, token);
    window.sessionStorage?.setItem(FLAG_KEY, "1");
  } catch { /* no-op */ }
};

export const clearPreviewToken = () => {
  try {
    window.sessionStorage?.removeItem(TOKEN_KEY);
    window.sessionStorage?.removeItem(FLAG_KEY);
  } catch { /* no-op */ }
};

// Return axios/fetch headers for the current preview session. Empty object
// when no token is present, so callers can spread it unconditionally.
export const previewHeaders = () => {
  const token = getPreviewToken();
  return token ? { "X-Preview-Token": token } : {};
};
